<template>
    <div
        v-if="isOpen"
        class="ppv2-fixed ppv2-inset-0 ppv2-flex ppv2-items-center ppv2-justify-center !ppv2-bg-black !ppv2-bg-opacity-70 ppv2-z-[9999]"
        @click.self="onCancel"
    >
        <div
            ref="popupContainer"
            :style="{
                width: '70%',
                maxWidth: '780px',
                minWidth: '450px',
                borderRadius: normalizeSize(43, true),
                maxHeight: '80vh',
            }"
            class="ConfirmationDialog ppv2-relative ppv2-overflow-y-auto noScrollBar ppv2-block ppv2-border-[1.81px] ppv2-border-[#5667A1] ppv2-min-w-80"
        >
            <!-- Header -->
            <div
                class="headerFix ppv2-sticky ppv2-top-0 ppv2-z-10 ppv2-py-2 ppv2-mb-4 ppv2-transition-shadow ppv2-duration-300"
                :class="{ 'header-scrolled': isScrolled }"
                :style="{
                    borderTopLeftRadius: normalizeSize(43, true),
                    borderTopRightRadius: normalizeSize(43, true),
                    paddingTop: normalizeSizeVertical(35, true),
                    paddingRight: normalizeSize(40, true),
                    paddingLeft: normalizeSize(40, true),
                }"
            >
                <div class="ppv2-text-black ppv2-relative" :style="{ fontSize: normalizeFontSize(20) }">
                    <span v-if="title" class="poppinsSemiBold">{{ title }}</span>
                    <div @click="onCancel" class="cursor-pointer ppv2-absolute ppv2-right-[-26px] ppv2-top-0">
                        <X color="#505D92" :size="38" />
                    </div>
                </div>

                <!-- Icône selon le type -->
                <!--                <div class="ppv2-flex ppv2-justify-center ppv2-mt-4 ppv2-mb-2">
                    <div
                        v-if="type === 'danger'"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-h-16 ppv2-w-16 ppv2-rounded-full ppv2-bg-red-100"
                    >
                        <svg
                            class="ppv2-h-8 ppv2-w-8 ppv2-text-red-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            />
                        </svg>
                    </div>
                    <div
                        v-else-if="type === 'warning'"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-h-16 ppv2-w-16 ppv2-rounded-full ppv2-bg-yellow-100"
                    >
                        <svg
                            class="ppv2-h-8 ppv2-w-8 ppv2-text-yellow-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            />
                        </svg>
                    </div>
                    <div
                        v-else-if="type === 'info'"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-h-16 ppv2-w-16 ppv2-rounded-full ppv2-bg-blue-100"
                    >
                        <svg
                            class="ppv2-h-8 ppv2-w-8 ppv2-text-blue-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>
                    <div
                        v-else-if="type === 'success'"
                        class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-h-16 ppv2-w-16 ppv2-rounded-full ppv2-bg-green-100"
                    >
                        <svg
                            class="ppv2-h-8 ppv2-w-8 ppv2-text-green-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 13l4 4L19 7"
                            />
                        </svg>
                    </div>
                </div>-->
            </div>

            <!-- Contenu -->
            <div
                class="ppv2-flex ppv2-flex-col ppv2-justify-center ppv2-items-center ppv2-min-h-[200px]"
                :style="{
                    borderBottomLeftRadius: normalizeSize(43, true),
                    borderBottomRightRadius: normalizeSize(43, true),
                    paddingBottom: normalizeSizeVertical(40, true),
                    paddingRight: normalizeSize(40, true),
                    paddingLeft: normalizeSize(40, true),
                }"
            >
                <!-- Message -->
                <div class="ppv2-text-center ppv2-mb-6">
                    <p class="ppv2-text-black" :style="{ fontSize: normalizeFontSize(16) }">
                        {{ message }}
                    </p>
                </div>

                <!-- Actions -->
                <div class="ppv2-flex ppv2-justify-center" :style="{ gap: normalizeSize(16, true) }">
                    <BaseButton v-if="!hideCancel" type="button" @click="onCancel" variant="outline" :customHeight="45">
                        {{ cancelButtonText }}</BaseButton
                    >
                    <BaseButton type="button" @click="onConfirm" variant="primary" :customHeight="45">
                        {{ confirmButtonText }}</BaseButton
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { X } from 'lucide-vue'
import normalizeSize from '../../utils/normalizeSize'
import normalizeSizeVertical from '../../utils/normalizeSizeVertical'
import BaseButton from './BaseButton.vue'
import normalizeFontSize from '../../utils/normalizeFontSize'
export default {
    name: 'ConfirmationDialog',
    components: {
        X,
        BaseButton,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            required: true,
        },
        confirmText: {
            type: String,
            default: '',
        },
        cancelText: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'info', // 'info', 'warning', 'danger', 'success'
            validator: (value) => ['info', 'warning', 'danger', 'success'].includes(value),
        },
        confirmButtonVariant: {
            type: String,
            default: 'primary',
            validator: (value) => ['primary', 'danger', 'success', 'warning', 'info'].includes(value),
        },
        hideCancel: {
            type: Boolean,
            default: false,
        },
        forceButtonsRow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isScrolled: false,
        }
    },
    computed: {
        confirmButtonText() {
            if (this.confirmText) return this.confirmText
            return this.$t('common.confirm') || 'Confirm'
        },
        cancelButtonText() {
            if (this.cancelText) return this.cancelText
            return this.$t('common.cancel') || 'Cancel'
        },
        buttonClass() {
            const variants = {
                primary: 'ppv2-bg-blue-600 hover:ppv2-bg-blue-700 ppv2-text-white focus:ppv2-ring-blue-500',
                danger: 'ppv2-bg-red-600 hover:ppv2-bg-red-700 ppv2-text-white focus:ppv2-ring-red-500',
                warning: 'ppv2-bg-yellow-600 hover:ppv2-bg-yellow-700 ppv2-text-white focus:ppv2-ring-yellow-500',
                success: 'ppv2-bg-green-600 hover:ppv2-bg-green-700 ppv2-text-white focus:ppv2-ring-green-500',
                info: 'ppv2-bg-blue-600 hover:ppv2-bg-blue-700 ppv2-text-white focus:ppv2-ring-blue-500',
            }
            return variants[this.confirmButtonVariant] || variants.primary
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSizeVertical,
        normalizeSize,
        onConfirm() {
            this.$emit('confirm')
        },
        onCancel() {
            this.$emit('cancel')
        },
        handleScroll(event) {
            this.isScrolled = event.target.scrollTop > 10
        },
        handleKeydown(e) {
            if (e.key === 'Escape') {
                this.onCancel()
            }
        },
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                document.body.style.overflow = 'hidden'
                document.addEventListener('keydown', this.handleKeydown)
            } else {
                document.body.style.overflow = ''
                document.removeEventListener('keydown', this.handleKeydown)
            }
        },
    },
    beforeDestroy() {
        document.body.style.overflow = ''
        document.removeEventListener('keydown', this.handleKeydown)
    },
    mounted() {
        if (this.isOpen) {
            document.body.style.overflow = 'hidden'
            document.addEventListener('keydown', this.handleKeydown)
        }
    },
}
</script>

<style scoped>
.ConfirmationDialog {
    background-color: #fff;
    display: flex;
    flex-direction: column;
}

/* Header fixe */
.headerFix {
    margin-bottom: 1rem;
}

/* Effet d'ombre lors du défilement */
.header-scrolled {
    background: inherit;
}

/* Mode sombre */
.dark .ConfirmationDialog {
    background-color: #141243;
    box-shadow:
        inset 0 0 36px #2b3362,
        0 14px 45px rgba(0, 0, 0, 0.5);
}

.dark .ConfirmationDialog:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('/media/bo/backgounds/bgPopup.png');
    background-repeat: repeat;
    opacity: 0.02;
    z-index: -1;
}

.dark .header-scrolled {
    box-shadow: inset 0 5px 10px #2b3362;
}

.dark .ppv2-text-gray-700 {
    color: #bfbfbf;
}

.dark .ppv2-text-black {
    color: #ffffff;
}

/* Contenu scrollable */
.ppv2-overflow-y-auto {
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* Masquer la barre de défilement */
.noScrollBar {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.noScrollBar::-webkit-scrollbar {
    display: none;
}
</style>
